module.exports = __webpack_public_path__ + "img/course120_curriculum.b4ac52ae.png";